// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpGdprConfigurar extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.configurar";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprConfigurar {
        this.VALUES ??= this.completar({
            "valor": {
                "ca": "Configurar",
                "cs": "Nastavit",
                "da": "Konfigurer",
                "de": "Konfigurieren",
                "en": "Configure",
                "es": "Configurar",
                "eu": "Konfiguratu",
                "fi": "Määritä",
                "fr": "Configurer",
                "gl": "Configurar",
                "hi": "कॉन्फ़िगर करें",
                "hu": "Konfigurál",
                "it": "Configurare",
                "nl": "Configureren",
                "no": "Konfigurer",
                "pl": "Konfiguruj",
                "pt": "Configurar",
                "ro": "Configura",
                "ru": "Настроить",
                "sk": "Nastaviť",
                "sv": "Konfigurera",
                "tr": "Yapılandır",
                "pt-BR": "Configurar"
            },
            "defecto": "Configure"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
